"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  youHaveUnsavedChangesBeforeLeave: 'There is unsaved data. Are you sure you want to leave the page?',
  numberCantBeMore: 'The number must be no more than 10000',
  stringHasErrors: 'The string contains an error, the data is not saved'
};